<template>
  <b-sidebar
    :id="drawer.id"
    :title="drawer.title"
    backdrop-variant="dark"
    backdrop
    right
    shadow
    no-close-on-backdrop
    no-close-on-esc
    width="620px"
    :visible="drawer.visible"
    sidebar-class="right-drawer white-drawer"
    aria-hidden="false"
    @hidden="onClose"
    @shown="handleDrawerShown"
  >
    <div
      v-if="['add', 'edit'].includes(mode)"
      class="p-2"
    >
      <ValidationObserver
        ref="formObserver"
        #default="{ invalid }"
      >
        <section class="mb-[2rem]">
          <div class="mb-[2rem] space-y-[.75rem]">
            <p class="font-semibold text-lg">
              Form Data Talent
            </p>
            <div>
              <BFormGroup
                label="Partner"
                class="text-black font-medium"
              >
                <BFormInput
                  id="partner_name"
                  v-model="partner"
                  :disabled="true"
                />
              </BFormGroup>
              <b-form-group
                class="text-black font-medium"
              >
                <template #label>
                  Layanan<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Layanan"
                  rules="required"
                >
                  <v-select
                    v-model="role"
                    :reduce="option => option.name"
                    :options="listSkills"
                    :loading="isLoadingSkills"
                    label="name"
                    :clearable="false"
                    :disabled="isDisableFormField('role')"
                    placeholder="Ketik untuk mencari..."
                    @input="() => {
                      listTalent = []
                      talent = null
                    }"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Nama Talent<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Nama Talent"
                  rules="required"
                >
                  <v-select
                    v-model="talent"
                    :reduce="option => option"
                    :options="filteredListTalent"
                    :loading="isLoadingTalents"
                    placeholder="Ketik untuk mencari..."
                    :disabled="isDisableFormField('talent') || !role"
                    @search="(search) => search.length > 0 ? onSearchTalent(search) : ''"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Talent Lead<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Talent Lead"
                  rules="required"
                >
                  <v-select
                    v-model="leader"
                    label="name"
                    :reduce="option => option"
                    :options="listLeader"
                    :loading="isLoadingLeads && !isDisableFormField('leader')"
                    :disabled="isDisableFormField('leader')"
                    placeholder="Ketik untuk mencari..."
                    @search="(search) => search.length > 0 ? onSearchLeader(search) : ''"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                v-if="isChangeTalentLeadAction"
                class="text-black font-medium"
              >
                <template #label>
                  Talent Lead Baru<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Talent Lead Baru"
                  :rules="isChangeTalentLeadAction ? 'required' : ''"
                >
                  <v-select
                    v-model="newLeader"
                    label="name"
                    :reduce="option => option"
                    :loading="isLoadingLeads"
                    :options="listLeader"
                    placeholder="Ketik untuk mencari..."
                    @search="(search) => search.length > 0 ? onSearchLeader(search) : ''"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Device<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Device"
                  rules="required"
                >
                  <v-select
                    v-model="device"
                    label="device_name"
                    :reduce="option => option"
                    :options="filteredListDevice"
                    :loading="isLoadingDevices"
                    placeholder="Ketik untuk mencari..."
                    :disabled="isDisableFormField('device')"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Kantor<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Kantor"
                  rules="required"
                >
                  <v-select
                    v-model="office"
                    label="working_space_name"
                    :reduce="option => option"
                    :options="listOffice"
                    :loading="isLoadingOffices && !isDisableFormField('office')"
                    placeholder="Ketik untuk mencari..."
                    :disabled="isDisableFormField('office')"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                v-if="isChangeOfficeAction"
                class="text-black font-medium"
              >
                <template #label>
                  Kantor Baru<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Kantor Baru"
                  :rules="isChangeOfficeAction ? 'required' : ''"
                >
                  <v-select
                    v-model="newOffice"
                    label="working_space_name"
                    :reduce="option => option"
                    :options="listOffice"
                    :loading="isLoadingOffices"
                    placeholder="Ketik untuk mencari..."
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="flex gap-[.75rem]">
                <BFormGroup class="text-black font-medium w-full">
                  <template #label>
                    Tanggal Ditetapkan<span class="text-danger">*</span>
                  </template>

                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="Tanggal Ditetapkan"
                    class="w-full"
                  >
                    <input
                      v-model="legitAt"
                      type="date"
                      class="form-control w-full"
                      placeholder="Pilih Tanggal"
                      :disabled="isDisableFormField('legitAt')"
                    >
                    <span
                      v-if="errors.length"
                      class="text-danger d-block mt-[2px] text-sm font-normal"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </BFormGroup>
                <BFormGroup class="text-black font-medium w-full">
                  <template #label>
                    Tanggal Berlaku<span class="text-danger">*</span>
                  </template>

                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="Tanggal Berlaku"
                    class="w-full"
                  >
                    <input
                      v-model="applyAt"
                      type="date"
                      class="form-control w-full"
                      placeholder="Pilih Tanggal"
                      :disabled="isDisableFormField('applyAt')"
                    >
                    <span
                      v-if="errors.length"
                      class="text-danger d-block mt-[2px] text-sm font-normal"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </BFormGroup>
              </div>
            </div>
          </div>
          <div v-show="isShowIncentiveForm">
            <p class="font-semibold text-lg">
              Form Insentif Talent
            </p>
            <div>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Gaji Pokok<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Gaji Pokok"
                  :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                >
                  <b-form-input
                    v-model.number="incentive.base_salary"
                    number
                    placeholder="Masukkan nominal"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="[&_legend]:text-[#4A5565] [&_legend]:ml-[16px] [&_legend]:truncate [&_legend]:!max-w-[120px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Performa Chat<span class="text-danger">*</span>
                </div>
                <b-form-group
                  label-cols="4"
                  class="!mb-[12px]"
                >
                  <template #label>
                    Rate >95%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate >95%"
                    :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_high"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label-cols="4"
                  class="!mb-[12px]"
                >
                  <template #label>
                    Rate 85%-95%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate 85%-95%"
                    :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_mid"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label-cols="4">
                  <template #label>
                    Rate &lt;85%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate <85%"
                    :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_low"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Update postingan (Feeds)<span class="text-danger">*</span>
                </div>
                <div class="flex items-start gap-x-[20px] gap-y-[12px] flex-wrap w-fit max-w-[460px] md:max-w-none">
                  <div class="flex items-start gap-[12px] basis-[240px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="per post"
                      :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                    >
                      <b-form-input
                        v-model.number="incentive.update_posting_rate"
                        number
                        placeholder="Masukkan nominal"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">per post</span>
                  </div>
                  <div class="flex items-start gap-[12px] basis-[200px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="post/bulan (max)"
                      :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                    >
                      <b-form-input
                        v-model.number="incentive.update_posting_max"
                        number
                        placeholder="0"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">post/bulan (max)</span>
                  </div>
                </div>
              </div>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Update Video<span class="text-danger">*</span>
                </div>
                <div class="flex items-start gap-x-[20px] gap-y-[12px] flex-wrap w-fit max-w-[460px] md:max-w-none">
                  <div class="flex items-start gap-[12px] basis-[240px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="per video"
                      :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                    >
                      <b-form-input
                        v-model.number="incentive.update_video_rate"
                        number
                        placeholder="Masukkan nominal"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">per video</span>
                  </div>
                  <div class="flex items-start gap-[12px] basis-[200px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="video/bulan (max)"
                      :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                    >
                      <b-form-input
                        v-model.number="incentive.update_video_max"
                        number
                        placeholder="0"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">video/bulan (max)</span>
                  </div>
                </div>
              </div>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Update Produk<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Update Produk"
                  :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                >
                  <b-form-input
                    v-model.number="incentive.update_product_rate"
                    number
                    placeholder="Masukkan nominal"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Bonus Penjualan<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Bonus Penjualan"
                  :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.sales_bonus_percentage"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">% dari penjualan/bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Invoice<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Invoice"
                  :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.invoice_rate"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per invoice</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Broadcast<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Broadcast"
                  :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.broadcast_rate"
                      number
                      placeholder="Masukkan nominal broadcast"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Setting Iklan<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Setting Iklan"
                  :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.setting_ads_rate"
                      number
                      placeholder="Masukkan nominal setting iklan"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Setting Affiliate<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Setting Affiliate"
                  :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                >
                  <b-form-input
                    v-model.number="incentive.setting_affiliate_rate"
                    number
                    placeholder="Masukkan nominal setting affiliate"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Lembur<span class="text-danger">*</span>
                </div>
                <div class="flex items-start gap-[12px] flex-wrap">
                  <validation-provider
                    #default="{ errors }"
                    name="overtime"
                    :rules="isShowIncentiveForm ? 'required|integer|min_value:0' : ''"
                    class="basis-[200px] grow"
                  >
                    <b-form-input
                      v-model.number="incentive.overtime_rate"
                      number
                      placeholder="Masukkan nominal lembur"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                  <validation-provider
                    #default="{ errors }"
                    name="post/bulan (max)"
                    :rules="isShowIncentiveForm ? 'required' : ''"
                    class="basis-[120px] grow sm:grow-0"
                  >
                    <v-select
                      v-model="incentive.overtime_type"
                      label="text"
                      :reduce="option => option.value"
                      :options="overtimeTypes"
                      :clearable="false"
                      class="[&_ul]:!min-w-[120px] [&>div]:h-[34.55px] [&_span]:!m-0"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="isAddMode"
          >
            <div
              v-if="temp_id"
              class="flex justify-end gap-[.75rem]"
            >
              <BButton
                variant="outline-primary"
                :disabled="isFormEmpty"
                @click="() => resetAssignment({ withMultipleAssign: false, withLegitApplyDate: true })"
              >
                Batalkan
              </BButton>
              <BButton
                variant="primary"
                :disabled="invalid"
                @click="updateTalentListMultipleAssign"
              >
                <div class="inline-block flex items-center">
                  <span class="k-add scale-110" />
                  <span class="ms-[.75rem]">Simpan Perubahan</span>
                </div>
              </BButton>
            </div>
            <div
              v-else
              class="flex justify-end"
            >
              <BButton
                variant="outline-primary"
                :disabled="invalid"
                class="ms-auto"
                @click="addToTalentListMultipleAssign"
              >
                <span class="k-add me-[.5rem]" />
                <span>Tambah Talent</span>
              </BButton>
            </div>
          </div>

        </section>
        <section
          v-if="talentListMultipleAssign.length > 0"
          class="mb-[2rem]"
        >
          <p class="font-semibold text-lg">
            List Talent Multiple Assign
          </p>
          <BTable
            :items="talentListMultipleAssign"
            :fields="tableTalentField"
            responsive
            show-empty
            class="zero-padding-td-b-table bordered-body-b-table"
          >
            <template #cell(talent_name)="data">
              <div class="p-[.75rem]">
                <TalentRow
                  :data="{
                    talent_name: data.item.talent.full_name,
                    skill_name: data.item.talent.skill_name,
                    avatar_url: data.item.talent.photo_profile_url,
                  }"
                  align-center
                  with-badge
                  :badge-auto-margin="false"
                >
                  <template #subTitle>
                    <span class="truncate w-[90%] inline-block">Lead: {{ data.item.leader.name }}</span>
                  </template>
                </TalentRow>
              </div>
            </template>
            <template #cell(action)="data">
              <div class="flex items-center justify-center gap-[.5rem]">
                <BButton
                  variant="link"
                  class="talent-table-edit-btn"
                  @click="() => editFromTalentListMultipleAssign(data.item.temp_id)"
                >
                  <span class="k-edit color-[#0A0A0A]!" />
                </BButton>
                <BButton
                  variant="link"
                  class="talent-table-delete-btn"
                  @click="() => deleteFromTalentListMultipleAssign(data.item.temp_id)"
                >
                  <span class="k-trash" />
                </BButton>
              </div>
            </template>
          </BTable>
        </section>
        <section
          v-if="isShowPreviewSK(invalid)"
          class="mb-[2rem]"
        >
          <p class="mb-[.5rem] font-semibold text-lg">
            Preview SK
          </p>
          <PreviewSK :data="previewSKData" />
        </section>
        <div class="flex gap-[.5rem]">
          <BButton
            variant="light"
            block
            @click="onClose"
          >
            Batalkan
          </BButton>
          <BButton
            variant="primary"
            :disabled="(talentListMultipleAssign.length > 0 ? false : invalid) || loadingSubmit"
            class="mt-0!"
            block
            @click="generateOrUpdateSK"
          >
            <BSpinner
              v-if="loadingSubmit"
              small
            />
            <span v-else>{{ drawer.title === TALENT_ACTION.ACTION_EDIT_DEVICE ? 'Update' : 'Generate SK' }}</span>
          </BButton>
        </div>
      </ValidationObserver>
    </div>
    <div
      v-else
      class="p-2"
    >
      <ValidationObserver
        ref="forceOffFormObserver"
        #default="{ invalid }"
      >
        <b-form-group
          class="text-black font-medium"
        >
          <template #label>
            Tipe Request
          </template>
          <validation-provider
            #default="{ errors }"
            name="Tipe Request"
          >
            <v-select
              v-model="forceOff.requestType"
              :options="['Off Talent']"
              :clearable="false"
              :disabled="true"
              placeholder="Ketik untuk mencari..."
            />
            <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <BFormGroup class="text-black font-medium w-full">
          <template #label>
            Tanggal Efektif Final<span class="text-danger">*</span>
          </template>

          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            name="Tanggal Efektif Final"
            class="w-full"
          >
            <input
              v-model="forceOff.finalApplyAt"
              type="date"
              class="form-control w-full"
              :min="minDate"
            >
            <span
              v-if="errors.length"
              class="text-danger d-block mt-[2px] text-sm font-normal"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </BFormGroup>
        <BFormGroup class="text-black font-medium w-full">
          <template #label>
            Alasan<span class="text-danger">*</span>
          </template>

          <ValidationProvider
            v-slot="{ errors }"
            rules="required|max:300"
            name="Alasan"
            class="w-full"
          >
            <BFormTextarea
              v-model="forceOff.reason"
              class="w-full"
              placeholder="Ketik sesuatu.."
            />
            <span
              v-if="errors.length"
              class="text-danger d-block mt-[2px] text-sm font-normal"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </BFormGroup>
        <div class="flex gap-[.5rem]">
          <BButton
            variant="light"
            block
            @click="onClose"
          >
            Batalkan
          </BButton>
          <BButton
            variant="primary"
            :disabled="invalid || loadingSubmit"
            block
            @click="forceOffTalent"
          >
            <BSpinner
              v-if="loadingSubmit"
              small
            />
            <span v-else>Off Talent</span>
          </BButton>
        </div>
      </ValidationObserver>
    </div>
  </b-sidebar>
</template>

<style scoped>
.btn-outline-primary,
.btn-primary,
.btn-light,
.btn-secondary,
.btn-link {
  border-radius: 10px;
}

.btn-primary {
  margin-top: 0 !important;
}

.btn:not(:disabled):not(.disabled).outline-primary-deny,
.btn.disabled {
  cursor: not-allowed !important;
}

.btn:not(:disabled):not(.disabled).outline-primary-deny:focus {
    background-color: white !important;
}

.talent-table-edit-btn.btn-link {
  box-shadow:
    inset 0 1px 0 #ddd,
    inset 0 -1px 0 #ddd,
    inset 1px 0 0 #ddd,
    inset -1px 0 0 #ddd !important;
    color: #0A0A0A !important;
}

.talent-table-delete-btn.btn-link {
  box-shadow:
    inset 0 1px 0 #FFDBDC,
    inset 0 -1px 0 #FFDBDC,
    inset 1px 0 0 #FFDBDC,
    inset -1px 0 0 #FFDBDC !important;
    background-color: #FFF7F7 !important;
    color: #DC2626 !important;
}
</style>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import VSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'
import { komtimAxiosIns } from '@/libs/axios'
import { downloadFileFromBlob } from '@/libs/downloadFile'
import { YEAR_MONTH_DAY } from '@/libs/filterDate'
import {
  DEFAULT_INCENTIVE, showError, showSuccess, tableMultipleAssign, TALENT_ACTION,
} from './config'
import TalentRow from './TalentRow.vue'
import PreviewSK from './templates/PreviewSK.vue'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VSelect,
    TalentRow,
    PreviewSK,
  },
  props: {
    drawer: {
      type: Object,
      default: () => ({
        visible: false,
        id: 'add-or-edit-talent-drawer',
        title: 'Judul Drawer',
        mode: '',
        isLoading: false,
        data: () => ({
          partner_id: null,
          partner_name: '',
          no_partner: null,
          talent_id: null,
          talent_name: '',
          avatar_url: '',
          skill_name: '',
          talent_lead_id: null,
          talent_lead_name: '',
          talent_lead_avatar_url: '',
          device: '',
          start_date: '',
          published_date: '',
        }),
      }),
    },
  },
  data() {
    return {
      required,
      loadingSubmit: false,
      isLoadingSkills: false,
      isLoadingTalents: false,
      isLoadingLeads: false,
      isLoadingDevices: false,
      isLoadingOffices: false,

      listTalent: [],
      listLeader: [],
      listDevice: [],
      listOffice: [],
      listSkills: [],

      temp_id: null,
      partner: null,
      talent: null,
      leader: null,
      newLeader: null,
      device: null,
      role: null,
      office: null,
      newOffice: null,
      legitAt: null,
      applyAt: null,

      incentive: { ...DEFAULT_INCENTIVE },
      overtimeTypes: [
        { text: 'per jam', value: 'hourly' },
        { text: 'per hari', value: 'daily' },
      ],

      talentListMultipleAssign: [],
      tableTalentField: tableMultipleAssign,

      allowedEditFields: {
        'Ubah Device': ['device', 'legitAt', 'applyAt'],
        'Ganti Talent Lead': ['legitAt', 'applyAt'],
        'Ganti Kantor': ['legitAt', 'applyAt'],
      },

      forceOff: {
        requestType: 'Off Talent',
        finalApplyAt: '',
        reason: '',
      },
      TALENT_ACTION,
      userFriendlyErrorMessage: {
        'Duplicate talent-partner pair in request': 'Talent ini sudah aktif di partner terkait',
      },
    }
  },
  computed: {
    roleId() {
      return this.role ? this.listSkills.find(s => s.name === this.role).id : ''
    },
    isAdminMarketplace() {
      return this.role === 'Admin Marketplace'
    },
    isAddMode() {
      return this.drawer.mode === 'add'
    },
    isShowIncentiveForm() {
      return this.isAdminMarketplace && this.isAddMode
    },

    mode() {
      return this.drawer.mode
    },
    isChangeTalentLeadAction() {
      return this.drawer.title === 'Ganti Talent Lead'
    },
    isChangeOfficeAction() {
      return this.drawer.title === 'Ganti Kantor'
    },
    minDate() {
      return YEAR_MONTH_DAY(new Date())
    },
    filteredListTalent() {
      if (!this.talentListMultipleAssign.length) return this.listTalent.filter(talent => talent.skill_name === this.role)

      const assignedTalentIds = new Set()
      this.talentListMultipleAssign.forEach(item => {
        const id = item.talent?.id
        if (item.temp_id !== this.temp_id && id) {
          assignedTalentIds.add(String(id))
        }
      })

      return this.listTalent.filter(talent => !assignedTalentIds.has(String(talent.id)) && talent.skill_name === this.role)
    },
    filteredListDevice() {
      if (!this.talentListMultipleAssign.length) return this.listDevice

      const assignedDeviceIds = new Set()
      this.talentListMultipleAssign.forEach(item => {
        const id = item.device?.id
        if (item.temp_id !== this.temp_id && id) {
          assignedDeviceIds.add(String(id))
        }
      })

      return this.listDevice.filter(device => !assignedDeviceIds.has(String(device.id)))
    },
    isFormEmpty() {
      const isFieldsEmpty = !this.role
        && !this.talent
        && !this.leader
        && !this.newLeader
        && !this.device
        && !this.office
        && !this.newOffice
        && !this.legitAt
        && !this.applyAt

      if (!this.isAdminMarketplace) return isFieldsEmpty

      const isIncentiveEmpty = Object.entries(this.incentive || {}).every(([key, val]) => {
        if (key === 'overtime_type') return true
        if (key === 'update_posting_max' || key === 'update_video_max') return Number(val) === 0
        return val === '' || val === null || val === undefined
      })

      return isFieldsEmpty && isIncentiveEmpty
    },
    previewSKData() {
      const actionSource = this.drawer.title
      const talentForm = {
        partner: this.partner,
        talent: this.talent,
        leader: this.leader,
        newLeader: this.newLeader,
        device: this.device,
        role: this.role,
        office: this.office,
        newOffice: this.newOffice,
        legitAt: this.legitAt,
        applyAt: this.applyAt,
      }
      if (this.isAdminMarketplace) talentForm.incentive = this.incentive

      const talents = this.talentListMultipleAssign.length < 1 ? [
        talentForm,
      ] : this.talentListMultipleAssign

      const tableItems = talents.map(item => {
        let columns = []
        switch (actionSource) {
          case TALENT_ACTION.ACTION_ADD:
            columns = [
              item.talent.full_name,
              item.role,
              this.drawer.data?.partner_id,
              this.drawer.data?.partner_name,
              item.talent.status,
              item.office.working_space_name,
              item.leader.name,
            ]
            break
          case TALENT_ACTION.ACTION_EDIT_OFFICE:
            columns = [
              item.leader.name || item.leader,
              item.office.working_space_name || item.office,
              item.newOffice.working_space_name,
            ]
            break
          case TALENT_ACTION.ACTION_EDIT_TL:
            columns = [
              this.drawer.data?.partner_name,
              this.drawer.data?.partner_id,
              item.leader.name || item.leader,
              item.newLeader.name,
              item.newLeader.total_talent,
            ]
            break
          default:
            break
        }
        return columns
      })
      return { actionSource, tableItems }
    },
  },
  methods: {
    isShowPreviewSK(invalid) {
      if (this.talentListMultipleAssign.length > 0) return true
      return !invalid && [TALENT_ACTION.ACTION_ADD, TALENT_ACTION.ACTION_EDIT_TL, TALENT_ACTION.ACTION_EDIT_OFFICE].includes(this.drawer.title)
    },
    addToTalentListMultipleAssign() {
      const talentForm = {
        temp_id: Date.now(),
        partner: this.partner,
        talent: this.talent,
        leader: this.leader,
        device: this.device,
        role: this.role,
        office: this.office,
      }
      if (this.isAdminMarketplace) talentForm.incentive = this.incentive

      this.talentListMultipleAssign.push(talentForm)

      this.resetAssignment({ withMultipleAssign: false, withLegitApplyDate: false })
    },
    updateTalentListMultipleAssign() {
      const talentForm = {
        temp_id: this.temp_id,
        partner: this.partner,
        talent: this.talent,
        leader: this.leader,
        device: this.device,
        role: this.role,
        office: this.office,
      }
      if (this.isAdminMarketplace) talentForm.incentive = this.incentive

      const index = this.talentListMultipleAssign.findIndex(
        item => item.temp_id === talentForm.temp_id,
      )

      if (index !== -1) {
        this.$set(this.talentListMultipleAssign, index, talentForm)
        this.resetAssignment({ withMultipleAssign: false, withLegitApplyDate: false })
      }
    },
    editFromTalentListMultipleAssign(tempId) {
      const data = this.talentListMultipleAssign.find(
        item => item.temp_id === tempId,
      )
      if (!data) return

      this.temp_id = data.temp_id
      this.talent = data.talent
      this.leader = data.leader
      this.device = data.device
      this.role = data.role
      this.office = data.office
      this.incentive = data.incentive
    },
    deleteFromTalentListMultipleAssign(tempId) {
      const index = this.talentListMultipleAssign.findIndex(
        item => item.temp_id === tempId,
      )

      if (index !== -1) {
        this.talentListMultipleAssign.splice(index, 1)
      }
    },
    async generateOrUpdateSK() {
      switch (this.drawer.title) {
        case TALENT_ACTION.ACTION_ADD:
          this.createPartnerAssignment()
          break
        case TALENT_ACTION.ACTION_EDIT_DEVICE:
          this.updateDevice()
          break
        case TALENT_ACTION.ACTION_EDIT_TL:
          this.updateTalentLead()
          break
        case TALENT_ACTION.ACTION_EDIT_OFFICE:
          this.updateOffice()
          break
        default:
          break
      }
    },
    async downloadSK({ id }) {
      try {
        const url = `/v1/partner_assignments/sks/${id}/download`
        const response = await komtimAxiosIns.get(url, {
          responseType: 'blob',
        })
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const fileName = `SK_${id}.pdf`
        downloadFileFromBlob(blob, fileName)
      } catch (error) {
        showError(error)
      }
    },
    async createPartnerAssignment() {
      try {
        const talentAssignments = this.talentListMultipleAssign.length < 1 ? [
          {
            talent_id: this.talent.id,
            partner_id: this.drawer?.data.partner_id,
            device_id: this.device?.id,
            staff_id: this.leader.id,
            office_id: this.office.id,
            incentive: this.incentive?.base_salary ? this.incentive : null,
          },
        ] : this.talentListMultipleAssign.map(item => ({
          talent_id: item.talent.id,
          partner_id: this.drawer?.data.partner_id,
          device_id: item.device?.id,
          staff_id: item.leader.id,
          office_id: item.office.id,
          incentive: item.incentive?.base_salary ? item.incentive : null,
        }))

        const payload = {
          start_date: this.applyAt,
          published_date: this.legitAt,
          talent_assignments: talentAssignments,
        }

        this.loadingSubmit = true
        const url = '/v1/partner_assignments/store'
        const { data: { data } } = await komtimAxiosIns.post(url, payload)

        showSuccess({
          title: 'Perubahan Berhasil Disimpan!',
          content: 'DOWNLOAD_SK',
          message: `Nomor SK: *${data.sk_number}*`,
          onAction: () => {
            this.downloadSK({ id: data.sk_document_id })
          },
        })
        this.$emit('on-success-response-action')
        this.onClose()
      } catch (error) {
        const errorMessage = error?.response?.data?.meta?.message
        const title = this.userFriendlyErrorMessage[errorMessage] || 'Gagal Memperbarui Data!'
        showError({ title })
      } finally {
        this.loadingSubmit = false
      }
    },
    async updateDevice() {
      try {
        const payload = {
          new_device_id: this.device.id,
          start_date: this.applyAt,
          published_date: this.legitAt,
        }

        this.loadingSubmit = true
        const url = `/v1/partner_assignments/${this.drawer.data.sk_partner_assignment_id}/device`
        await komtimAxiosIns.put(url, payload)

        showSuccess({ title: 'Berhasil mengubah Device!' })
        this.$emit('on-success-response-action')
        this.onClose()
      } catch {
        showError({ title: 'Gagal mengubah Device!' })
      } finally {
        this.loadingSubmit = false
      }
    },
    async updateTalentLead() {
      try {
        const payload = {
          new_talent_lead_id: this.newLeader.id,
          start_date: this.applyAt,
          published_date: this.legitAt,
        }

        this.loadingSubmit = true
        const url = `/v1/partner_assignments/${this.drawer.data.sk_partner_assignment_id}/talent_lead`
        const { data: { data } } = await komtimAxiosIns.put(url, payload)

        showSuccess({
          title: 'Berhasil ganti Talent Lead!',
          content: 'DOWNLOAD_SK',
          message: `Nomor SK: *${data.sk_number}*`,
          onAction: () => {
            this.downloadSK({ id: data.sk_document_id })
          },
        })
        this.$emit('on-success-response-action')
        this.onClose()
      } catch {
        showError({ title: 'Gagal ganti Talent Lead!' })
      } finally {
        this.loadingSubmit = false
      }
    },
    async updateOffice() {
      try {
        const payload = {
          new_office_id: this.newOffice.id,
          start_date: this.applyAt,
          published_date: this.legitAt,
        }

        this.loadingSubmit = true
        const url = `/v1/partner_assignments/${this.drawer.data.sk_partner_assignment_id}/office`
        const { data: { data } } = await komtimAxiosIns.put(url, payload)

        showSuccess({
          title: 'Berhasil ganti Kantor!',
          content: 'DOWNLOAD_SK',
          message: `Nomor SK: *${data.sk_number}*`,
          onAction: () => {
            this.downloadSK({ id: data.sk_document_id })
          },
        })
        this.$emit('on-success-response-action')
        this.onClose()
      } catch {
        showError({ title: 'Gagal ganti Kantor!' })
      } finally {
        this.loadingSubmit = false
      }
    },
    async forceOffTalent() {
      try {
        const payload = {
          effective_date: this.forceOff.finalApplyAt,
          reason: this.forceOff.reason,
        }

        this.loadingSubmit = true
        const url = `/v1/partner_assignments/${this.drawer.data.sk_partner_assignment_id}/unassign`
        await komtimAxiosIns.put(url, payload)

        showSuccess({ title: 'Berhasil force off talent!' })
        this.$emit('on-success-response-action')
        this.onClose()
      } catch {
        showError({ title: 'Gagal force off talent!' })
      } finally {
        this.loadingSubmit = false
      }
    },
    /**
     * Handle close action
     */
    onClose() {
      this.resetAssignment()
      this.$emit('on-close')
    },
    resetAssignment(option = { withMultipleAssign: true, withLegitApplyDate: true }) {
      if (this.drawer.title === 'Force Off' && this.$refs.forceOffFormObserver) {
        this.forceOff = {
          requestType: 'Off Talent',
          finalApplyAt: '',
          reason: '',
        }
        this.$nextTick(() => {
          this.$refs.forceOffFormObserver.reset()
        })
        return
      }

      this.temp_id = null
      this.talent = null
      this.leader = null
      this.newLeader = null
      this.device = null
      this.role = null
      this.office = null
      this.newOffice = null
      this.incentive = { ...DEFAULT_INCENTIVE }

      if (option.withLegitApplyDate) {
        this.legitAt = null
        this.applyAt = null
      }

      this.listTalent = []
      this.listLeader = []
      if (option.withMultipleAssign) {
        this.talentListMultipleAssign = []
      }

      this.$nextTick(() => {
        this.$refs.formObserver.reset()
      })
    },
    async getListTalent(keyword) {
      this.isLoadingTalents = true
      this.offset = 0
      const params = `offset=0&limit=20&status=selected,hired,non job,multiple&keyword=${keyword}&skill=${this.roleId || ''}`
      const url = `v1/talents?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.listTalent = (data || []).map(e => ({ ...e, label: `${e.id} - ${e.full_name}` }))
        })
        .catch(err => {
          const errorMessage = err?.response?.data?.meta?.message
          showError({ title: errorMessage })
        }).finally(() => {
          this.isLoadingTalents = false
        })
    },
    searchTalent: _.debounce((search, it) => {
      it.getListTalent(search)
    }, 500),
    onSearchTalent(search) {
      this.searchTalent(search, this)
    },
    async getListLeader(keyword) {
      this.isLoadingLeads = true
      this.offset = 0
      const params = `offset=0&limit=20&position_name=Team Lead Non Advertiser,Team Lead Advertiser&keyword=${keyword}`
      const url = `v1/staffs?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.listLeader = data || []
        })
        .catch(err => {
          const errorMessage = err?.response?.data?.meta?.message
          showError({ title: errorMessage })
        }).finally(() => {
          this.isLoadingLeads = false
        })
    },
    searchLeader: _.debounce((search, it) => {
      it.getListLeader(search)
    }, 500),
    onSearchLeader(search) {
      this.searchLeader(search, this)
    },
    async getListOffice() {
      this.isLoadingOffices = true
      this.offset = 0
      const params = 'status=true'
      const url = `v1/working_spaces/resource?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.listOffice = data || []
        })
        .catch(err => {
          const errorMessage = err?.response?.data?.meta?.message
          showError({ title: errorMessage })
        }).finally(() => {
          this.isLoadingOffices = false
        })
    },
    async getListDevice() {
      this.isLoadingDevices = true
      this.offset = 0
      const params = `offset=0&limit=20&holder_name=IT Support&partner_id=${this.drawer.data.no_partner}`
      const url = `v1/devices?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.listDevice = data || []
        })
        .catch(err => {
          const errorMessage = err?.response?.data?.meta?.message
          showError({ title: errorMessage })
        }).finally(() => {
          this.isLoadingDevices = false
        })
    },
    handleInput(val) {
      if (this.mode === 'edit') return
      this.device = null
      if (val) {
        this.getListDevice()
      }
    },
    async getListSkills() {
      this.isLoadingSkills = true
      this.offset = 0
      const params = `active=${true}&type=2`
      const url = `v1/skills/resource?${params}`

      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.listSkills = data || []
        })
        .catch(err => {
          const errorMessage = err?.response?.data?.meta?.message
          showError({ title: errorMessage })
        }).finally(() => {
          this.isLoadingSkills = false
        })
    },
    loadData() {
      const { data } = this.drawer
      this.role = data.skill_name
      this.talent = data.talent_name
      this.leader = data.staff_name
      this.device = data.device
      this.office = data.office_name
      this.legitAt = data.published_date
      this.applyAt = data.start_date
      this.incentive = {}
    },
    handleDrawerShown() {
      this.partner = this.drawer.data?.partner_name
      if (this.mode === 'add') {
        this.legitAt = YEAR_MONTH_DAY(new Date())
      }
      this.getListOffice()
      this.getListSkills()
      this.getListDevice()
      if (this.mode === 'edit') {
        this.loadData()
      }
    },
    isDisableFormField(field) {
      const allowedExistField = this.allowedEditFields[this.drawer.title] || 'all'
      if (allowedExistField === 'all') return false
      return !allowedExistField.includes(field)
    },
  },
}
</script>
